import { render, staticRenderFns } from "./Rate_setting.vue?vue&type=template&id=9f8e2d38&scoped=true&"
import script from "./Rate_setting.vue?vue&type=script&lang=js&"
export * from "./Rate_setting.vue?vue&type=script&lang=js&"
import style0 from "./Rate_setting.vue?vue&type=style&index=0&id=9f8e2d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e2d38",
  null
  
)

export default component.exports